import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, withRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import {
  HelperFunctions, IndexJs, MsalConfig, MsalInstance,
} from '@westernmilling/react_component_library';

import App from 'App';

async function bootstrap() {
  HelperFunctions.suppressConsoleMessages();

  const AppWithRouterAccess = withRouter(App);

  const msalInstance = new PublicClientApplication(MsalConfig.config);
  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();

  await msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      msalInstance.setActiveAccount(event.payload.account);
    }
  });

  MsalInstance.setMsalInstance(msalInstance);

  createRoot(document.getElementById('root')).render(
    <IndexJs
      app={(
        <MsalProvider instance={msalInstance}>
          <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
            <AppWithRouterAccess />
          </BrowserRouter>
        </MsalProvider>
      )}
    />,
  );
}

bootstrap().catch((err) => {
  // eslint-disable-next-line no-console
  console.error('MSAL bootstrap failed:', err);
});
